import { Container } from "react-bootstrap";
import BodyCompositions from "../../compositions_components/body_compositions/components/body_compositions";

const Compositions = () => {
  return (
    <Container className="p-0 m-0 " fluid>
        <BodyCompositions/>
    </Container>
  );
};
export default Compositions;
